<mat-toolbar #sidenavHeader>
    <toolbar-title>{{ title }}</toolbar-title>

    <flex-spacer></flex-spacer>

    <button mat-icon-button disableRipple [attr.aria-label]="'Close ' + title.toLowerCase()" sidenav-close>
        <mat-icon>close</mat-icon>
    </button>
</mat-toolbar>

<mat-progress-bar mode="query" color="primary" [class.active]="loading$ | async"></mat-progress-bar>

<ng-template sidenavContentContainer></ng-template>

<mat-toolbar #sidenavActions [hidden]="!showActions"></mat-toolbar>
